<script>
    export let params;  // `params` will be passed as a prop by `svelte-spa-router`
    import { onMount } from 'svelte';
    import { push } from 'svelte-spa-router';
    import ClassName from './ClassNameComponent.svelte';
    import TeacherName from './TeacherNameComponent.svelte'
    import TimeShowerComponent from './TimeShowerComponent.svelte';
    import TimeShower from './TimeShowerComponent.svelte';
    import SendEmailLink from './RecieveEmailComponent.svelte';
    import ButtonToJoinClass from './ButtonToJoinClassComponent.svelte'
    import RescheduleButton from './ButtonToRescheduleComponent.svelte'
    import AvailableTimeSlotsPicker from './AvailableTimeSlotsPickerComponent.svelte'
    import DateTimePicker from './DateTimePickerForClassChangeComponent.svelte'
    import Button1 from './ButtonToGo.svelte'
    
    // Now you can use `params` directly
    let classId = params.id;
    let error = null;
    let classinfo ="nothing";
    let timePart = '';
    let formattedDate ='';
    let availableSlots = [];
    let isUserTeacher = false;
    let skipNotification = false;
    let additionalClass = false;
    let useComment = true;
    let comment = '';

    // Functions to handle mutual exclusion - at least one must be selected
    function handleSkipNotificationChange() {
        if (skipNotification) {
            additionalClass = false;
            useComment = false;
        } else {
            // Don't allow deselection - reselect it
            skipNotification = true;
        }
    }
    
    function handleAdditionalClassChange() {
        if (additionalClass) {
            skipNotification = false;
            useComment = false;
        } else {
            // Don't allow deselection - reselect it
            additionalClass = true;
        }
    }

    function handleUseCommentChange() {
        if (useComment) {
            skipNotification = false;
            additionalClass = false;
        } else {
            // Don't allow deselection - reselect it
            useComment = true;
        }
    }

    async function handleDateSubmit(event) {
        const token = localStorage.getItem('jwtToken');
        const selectedDateTime = event.detail.datetime;

        // Validate that if comment checkbox is selected, comment is not empty (only for teachers)
        if (isUserTeacher && useComment && (!comment || comment.trim() === '')) {
            alert('Prašome įvesti pakeitimo priežastį arba pasirinkti kitą variantą.');
            return;
        }

        try {
            const payload = { datetime: selectedDateTime };
            // Only teachers should ever send these fields.
            if (isUserTeacher) {
                payload.skip_notification = skipNotification;
                payload.additional_class = additionalClass;
                payload.comment = useComment ? comment : '';
            }

            const response = await fetch(`/studentplayground/reschedule/${classId}/`, {
                method: 'POST',
                headers: {
                   
                    'Authorization': `Bearer ${token}`,  // Send the token for authentication
                    'Content-Type': 'application/json'
                
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                push('/schedule?tab=reschedule');
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.error || response.statusText;
                alert(`Error: ${errorMessage}`);
            }
        } catch (error) {
            alert(`Error: ${error.message}`);
        }
    }

    

    const fetchRescheduleRequest = async (classId) => {
        const token = localStorage.getItem('jwtToken'); // Retrieve token from localStorage
        console.log("THis is the JWT TOKEN")
        console.log(token)
        if (!token) {
            console.error('No JWT token found. User might not be logged in.');
            return;
        }

        try {
            // Making a request to reschedule endpoint with the classId parameter
            const response = await fetch(`/studentplayground/reschedule/${classId}/`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,  // Send the token for authentication
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Reschedule Request Data:', data);
                classinfo = data.classinfo;
                availableSlots = data.available_slots || [];
                console.log('Available slots:', availableSlots);
                return data.classinfo;  // Return the classinfo data
            } else {
                if (response.status === 401) {
                    // If response is 401 Unauthorized, redirect to login
                    alert('Reikia prisijungti iš naujo.');
                    localStorage.removeItem('jwtToken'); // Optional: Clear any stored tokens
                    window.location.href = '#/about'; // Redirect to login page
                } else {
                    // Handle other errors
                    alert('Error submitting form!');
                }
            }
        } catch (error) {
            console.error("Error during reschedule request fetch:", error);
        }
    };
    const formatDateTime = (datetime) => {
        console.log("THis is dateimte")
        console.log(datetime)
        let parts = datetime.split(" ");
        let datePart = parts[0];
        let timePart = parts[1];
        let dayPart = parts[2];

        let formattedDate = `${dayPart}<br>${datePart}`;
            return { timePart, formattedDate };
    };
    async function checkIfUserIsTeacher() {
        const token = localStorage.getItem('jwtToken');
        if (!token) return false;
        
        try {
            const response = await fetch('/studentplayground/isUserTeacher/', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                return data.isUserTeacher;
            }
        } catch (error) {
            console.error("Error checking teacher status:", error);
        }
        return false;
    }

    onMount(async () => {
        isUserTeacher = await checkIfUserIsTeacher();
        fetchRescheduleRequest(classId);
    });
    $: if (classinfo && classinfo.time) {
        let { timePart: tp, formattedDate: fd } = formatDateTime(classinfo.time);
        timePart = tp;
        formattedDate = fd;
    }
    
</script>
    <div class="top-bar">
        
        <a href='#/reschedule-requests' class="exit-button">
        <img src='/static/icons/backButtonIcon.png' alt="Exit" class="icon" />
        </a>
        <div class="label">Keisti Rezervaciją</div>
        <div class="filler"></div>
    </div>

    <div class='classcontainer'>
        <ClassName name={classinfo.name} />
        <TeacherName teacher={classinfo.teacher}/>
        <TimeShower time={timePart} date={formattedDate} />
        {#if isUserTeacher}
            <!-- Teachers can pick any time and date -->
            <DateTimePicker on:submit={handleDateSubmit} />
            
            <!-- Checkbox for teachers to skip student notification -->
            <div class="notification-checkbox">
                <label class="checkbox-label">
                    <input 
                        type="checkbox" 
                        bind:checked={skipNotification}
                        on:change={handleSkipNotificationChange}
                        class="checkbox-input"
                    />
                    <span class="checkbox-text">Naujas laikas suderintas su mokiniu</span>
                </label>
                <div class="checkbox-description">
                    Pažymėkite šį laukelį tik tuo atveju, jei mokinys jau informuotas ir sutiko su pakeitimu. Tokiu atveju mokiniui nebus siunčiama užklausa patvirtinti – jis iškart gaus pranešimą apie sėkmingą pamokos pakeitimą.
                </div>
            </div>

            <!-- Checkbox for additional class -->
            <div class="notification-checkbox">
                <label class="checkbox-label">
                    <input 
                        type="checkbox" 
                        bind:checked={additionalClass}
                        on:change={handleAdditionalClassChange}
                        class="checkbox-input"
                    />
                    <span class="checkbox-text">Sutarta papildoma pamoka</span>
                </label>
                <div class="checkbox-description">
                    Pažymėkite šį laukelį tuo atveju, jei esate sutarę su mokinių organizuoti tokią pačią, papildomą pamoką nurodytu laiku.
                </div>
            </div>

            <!-- Checkbox for comment -->
            <div class="notification-checkbox">
                <label class="checkbox-label">
                    <input 
                        type="checkbox" 
                        bind:checked={useComment}
                        on:change={handleUseCommentChange}
                        class="checkbox-input"
                    />
                    <span class="checkbox-text">Pakeitimo priežastis:</span>
                </label>
                <textarea 
                    bind:value={comment}
                    disabled={!useComment}
                    placeholder="Įveskite pakeitimo priežastį..."
                    class="comment-textarea"
                    rows="4"
                ></textarea>
            </div>
        {:else}
            <!-- Students are restricted to available time slots -->
            <AvailableTimeSlotsPicker {availableSlots} on:submit={handleDateSubmit} />
        {/if}
        <Button1 link="/class/cancel-class/{classId}" label="Atšaukti Pamoką" />

    </div>
{#if error}
    <p>Error: {error}</p>
{/if}
<style>
   .top-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        background-color: transparent;
        border-bottom: 1px solid #000000;
        margin-bottom: 40px;
      
      }
      .filler {
        width:50px;
      }
    
      .label {
        font-size: x-large;
        color:#14695b;
        
      }
    
      .exit-button {
        max-width: 50px;
      }
    
      .icon {
        width: 50px;
        height: 50px;
      }
    p {
        font-size: 1.2em;
    }
    .classcontainer{
        padding: 15px;
        background-color: #eeebdb;
        
        
        margin-bottom:15px;
        
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
        border-radius: 8px;
       
        color:black;
        align-items: flex-start;

      }

  /* Notification checkbox styling */
  .notification-checkbox {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #dee2e6;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 8px;
  }

  .checkbox-input {
    margin-right: 10px;
    margin-left:10px;
    margin-top:10px;
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .checkbox-text {
    font-weight: 600;
    color: #495057;
    font-size: 16px;
  }

  .checkbox-description {
    font-size: 14px;
    color: #6c757d;
    font-style: italic;
    margin-left: 28px;
    line-height: 1.4;
  }

  .comment-textarea {
    width: 100%;
    margin-top: 10px;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    resize: vertical;
    font-family: inherit;
    transition: border-color 0.2s, background-color 0.2s;
  }

  .comment-textarea:enabled {
    background-color: white;
    border-color: #ced4da;
  }

  .comment-textarea:enabled:focus {
    outline: none;
    border-color: #14695b;
    box-shadow: 0 0 0 0.2rem rgba(20, 105, 91, 0.25);
  }

  .comment-textarea:disabled {
    background-color: #e9ecef;
    color: #6c757d;
    cursor: not-allowed;
  }
</style>
